// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.SecondaryTable_scroll__XqUCm::-webkit-scrollbar {
  height: 8px;
}
.SecondaryTable_scroll__XqUCm::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.SecondaryTable_scroll__XqUCm::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.SecondaryTable_SecondaryTable__TH\\+yE {
  text-transform: capitalize;
  position: relative;
}
.SecondaryTable_SecondaryTable__Container__MfLmA {
  overflow-y: scroll;
  scrollbar-width: none;
}
.SecondaryTable_SecondaryTable__Container__MfLmA ::-webkit-scrollbar {
  display: none;
}
.SecondaryTable_SecondaryTable__TableContent__TpiIU {
  background-color: var(--bgColor);
  padding: 20px;
  min-height: 272px;
}
.SecondaryTable_SecondaryTable__TopBar__USpRe {
  display: flex;
  justify-content: space-between;
  position: relative;
}
.SecondaryTable_SecondaryTable__TopBar__USpRe .SecondaryTable_Date__rXOIq {
  font-size: 12px !important;
}
.SecondaryTable_SecondaryTable__TopBar__USpRe .SecondaryTable_FiltersWrapper__fsnLE {
  display: flex;
  margin-bottom: 8px;
  align-items: center;
}
.SecondaryTable_SecondaryTable__TopBar__USpRe .SecondaryTable_Filters__hjD1c {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;
}
.SecondaryTable_SecondaryTable__TopBar__USpRe .SecondaryTable_Filters__hjD1c .SecondaryTable_SelectInput__mNCvs {
  flex-shrink: 0;
  width: 140px;
}
.SecondaryTable_SecondaryTable__TopBar__USpRe .SecondaryTable_Legend__mpuwa {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
}
.SecondaryTable_SecondaryTable__TopBar__USpRe .SecondaryTable_Legend__Item__u2-n7 {
  display: flex;
  align-items: center;
}
.SecondaryTable_SecondaryTable__TopBar__USpRe .SecondaryTable_Legend__Item__u2-n7:not(:last-child) {
  -webkit-margin-end: 20px;
          margin-inline-end: 20px;
}
.SecondaryTable_SecondaryTable__TopBar__USpRe .SecondaryTable_Legend__ColorBox__TOije {
  min-width: 12px;
  height: 12px;
  -webkit-margin-end: 4px;
          margin-inline-end: 4px;
  border: 1px solid;
}
@media (max-width: 1919px) {
  .SecondaryTable_SecondaryTable__TopBar__USpRe .SecondaryTable_Legend__mpuwa {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
  }
}
.SecondaryTable_SecondaryTable__TopBar__USpRe .SecondaryTable_Controls__sXO9J {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.SecondaryTable_SecondaryTable__TopBar__USpRe .SecondaryTable_Controls__sXO9J .SecondaryTable_ControlsItem__rmtX2 {
  cursor: pointer;
}
.SecondaryTable_SecondaryTable__TopBar__USpRe .SecondaryTable_Controls__sXO9J .SecondaryTable_ControlsItem__rmtX2:not(:last-of-type) {
  -webkit-padding-end: 10px;
          padding-inline-end: 10px;
  -webkit-border-end: 1px solid var(--borderColor);
          border-inline-end: 1px solid var(--borderColor);
}
.SecondaryTable_SecondaryTable__TopBar__USpRe .SecondaryTable_Controls__sXO9J .SecondaryTable_ControlsItem__rmtX2:nth-of-type(2) {
  -webkit-padding-start: 10px;
          padding-inline-start: 10px;
}
.SecondaryTable_SecondaryTable__TopBar__USpRe .SecondaryTable_Controls__sXO9J .SecondaryTable_ControlsItem__rmtX2 svg {
  transition: 0.3s;
}
.SecondaryTable_SecondaryTable__TopBar__USpRe .SecondaryTable_Controls__sXO9J .SecondaryTable_ControlsItem__rmtX2 svg:hover {
  color: var(--secondaryColor);
}
.SecondaryTable_SecondaryTable__TopBar__USpRe .SecondaryTable_Controls__sXO9J .SecondaryTable_ControlsItem__rmtX2 svg:hover line {
  stroke: var(--secondaryColor);
}
.SecondaryTable_SecondaryTable__TopBar__USpRe .SecondaryTable_Controls__sXO9J .SecondaryTable_ControlsItem__rmtX2 svg:hover path {
  stroke: var(--secondaryColor);
}
.SecondaryTable_SecondaryTable__TableRow__AddCell__ZC4Qc {
  opacity: 0;
  transition: all 0.4s;
  cursor: pointer;
}
.SecondaryTable_SecondaryTable__TableRow__msmzE:hover .SecondaryTable_SecondaryTable__TableRow__AddCell__ZC4Qc {
  opacity: 1;
}
.SecondaryTable_SecondaryTable__TableRow__msmzE:not(:last-child) {
  border-bottom: 1px solid var(--borderColor);
}
.SecondaryTable_SecondaryTable__TableRow__msmzE a {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  width: 90%;
  font-size: 10px;
  word-break: normal;
  letter-spacing: normal;
}
.SecondaryTable_SecondaryTable__SeeAll__jh8ag {
  border-top: 1px solid var(--borderColor);
  padding-top: 12px;
  text-align: center;
}
.SecondaryTable_SecondaryTable__SeeAll__jh8ag a {
  color: var(--secondaryColor);
  font-size: 10px !important;
}
.SecondaryTable_SecondaryTable__TH\\+yE .MuiTableCell-root {
  padding: 9px 0 !important;
  color: var(--mainColor) !important;
  text-transform: capitalize;
  font-size: 10px !important;
  line-height: 12px;
  max-width: 162px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: normal;
  letter-spacing: normal;
}
body[dir=ltr] .SecondaryTable_SecondaryTable__TH\\+yE .MuiTableCell-root {
  font-family: "LatoRegular", "CairoRegular", sans-serif;
}
body[dir=rtl] .SecondaryTable_SecondaryTable__TH\\+yE .MuiTableCell-root {
  font-family: "CairoRegular", "LatoRegular", sans-serif;
}
.SecondaryTable_SecondaryTable__TH\\+yE .MuiTableCell-root:first-of-type {
  padding-block: 10px;
}
.SecondaryTable_SecondaryTable__TH\\+yE .MuiTableCell-head {
  font-size: 12px !important;
  white-space: nowrap;
  -webkit-padding-end: 10px !important;
          padding-inline-end: 10px !important;
}
.SecondaryTable_SecondaryTable__TH\\+yE .MuiTableRow-root td:nth-child(2) {
  -webkit-padding-start: 10px !important;
          padding-inline-start: 10px !important;
}
.SecondaryTable_SecondaryTable__TH\\+yE .apexcharts-tooltip {
  padding: 17px 10px;
  overflow: visible;
  border-radius: 0;
  border: 1px solid var(--borderColor);
}
.SecondaryTable_SecondaryTable__TH\\+yE .apexcharts-tooltip * {
  vertical-align: middle;
}
.SecondaryTable_SecondaryTable__TH\\+yE .apexcharts-tooltip-title {
  display: none;
}
.SecondaryTable_SecondaryTable__TH\\+yE .apexcharts-tooltip-series-group {
  padding: 0;
}
.SecondaryTable_SecondaryTable__TH\\+yE .apexcharts-tooltip-marker {
  margin-right: 0;
  border-radius: 0;
}
body[dir=rtl] .SecondaryTable_SecondaryTable__TH\\+yE .apexcharts-tooltip-marker {
  margin-left: 10px;
}
body[dir=ltr] .SecondaryTable_SecondaryTable__TH\\+yE .apexcharts-tooltip-marker {
  margin-right: 10px;
}
.SecondaryTable_SecondaryTable__TH\\+yE .apexcharts-tooltip-y-group {
  font-size: 0;
}
.SecondaryTable_SecondaryTable__TH\\+yE .apexcharts-tooltip-text-value {
  margin-left: 0;
  -webkit-margin-start: 10px;
          margin-inline-start: 10px;
  font-size: 10px !important;
}
.SecondaryTable_SecondaryTable__TH\\+yE .SecondaryTable_noBorder__Mw7q7 {
  border-bottom: none !important;
}
.SecondaryTable_SecondaryTable__TH\\+yE a:hover {
  color: var(--secondaryColor) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/Tables/SecondaryTable/SecondaryTable.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAnDA;EACE,0BAAA;EACA,kBAAA;AAsDF;AArDE;EACE,kBAAA;EACA,qBAAA;AAuDJ;AAtDI;EACE,aAAA;AAwDN;AArDE;EACE,gCAAA;EACA,aAAA;EACA,iBAAA;AAuDJ;AApDE;EAEE,aAAA;EACA,8BAAA;EACA,kBAAA;AAqDJ;AAnDI;EDoFA,0BAAA;AC9BJ;AAnDI;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;AAqDN;AAnDI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,SAAA;AAqDN;AAnDM;EACE,cAAA;EACA,YAAA;AAqDR;AAjDI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAmDN;AAlDM;EACE,aAAA;EACA,mBAAA;AAoDR;AAnDQ;EACE,wBAAA;UAAA,uBAAA;AAqDV;AAlDM;EACE,eAAA;EACA,YAAA;EACA,uBAAA;UAAA,sBAAA;EACA,iBAAA;AAoDR;AAlDM;EAlBF;IAmBI,kBAAA;IACA,SAAA;IACA,SAAA;IACA,2BAAA;EAqDN;AACF;AAlDI;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AAoDN;AAnDM;EACE,eAAA;AAqDR;AApDQ;EACE,yBAAA;UAAA,wBAAA;EACA,gDAAA;UAAA,+CAAA;AAsDV;AApDQ;EACE,2BAAA;UAAA,0BAAA;AAsDV;AApDQ;EACE,gBAAA;AAsDV;AArDU;EACE,4BAAA;AAuDZ;AAtDY;EACE,6BAAA;AAwDd;AAtDY;EACE,6BAAA;AAwDd;AA/CI;EACE,UAAA;EACA,oBAAA;EACA,eAAA;AAiDN;AA/CI;EACE,UAAA;AAiDN;AA/CI;EACE,2CAAA;AAiDN;AA/CI;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;EAEA,kBAAA;EACA,sBAAA;AAgDN;AA3CE;EACE,wCAAA;EACA,iBAAA;EACA,kBAAA;AA6CJ;AA5CI;EACE,4BAAA;EDzBF,0BAAA;ACwEJ;AA1CI;EACE,yBAAA;EACA,kCAAA;EACA,0BAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,kBAAA;EACA,sBAAA;AA2CN;AAzCM;EACE,sDD9FM;ACyId;AAzCM;EACE,sDD/FO;AC0If;AAzCM;EAEE,mBAAA;AA0CR;AAhCI;ED5DA,0BAAA;EC8DE,mBAAA;EACA,oCAAA;UAAA,mCAAA;AAkCN;AA5BM;EACE,sCAAA;UAAA,qCAAA;AA8BR;AA1BI;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oCAAA;AA4BN;AA1BM;EACE,sBAAA;AA4BR;AAzBM;EACE,aAAA;AA2BR;AAxBM;EACE,UAAA;AA0BR;AAvBM;EACE,eAAA;EAOA,gBAAA;AAmBR;AAzBQ;EACE,iBAAA;AA2BV;AAzBQ;EACE,kBAAA;AA2BV;AAvBM;EACE,YAAA;AAyBR;AAtBM;EACE,cAAA;EACA,0BAAA;UAAA,yBAAA;ED9GJ,0BAAA;ACuIJ;AAnBE;EACE,8BAAA;AAqBJ;AAjBE;EACE,uCAAA;AAmBJ","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.SecondaryTable {\n  text-transform: capitalize;\n  position: relative;\n  &__Container {\n    overflow-y: scroll;\n    scrollbar-width: none;\n    ::-webkit-scrollbar {\n      display: none;\n    }\n  }\n  &__TableContent {\n    background-color: var(--bgColor);\n    padding: 20px;\n    min-height: 272px;\n  }\n\n  &__TopBar {\n    // margin-bottom: 8px;\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n\n    .Date {\n      @include fontSize(12);\n    }\n    .FiltersWrapper {\n      display: flex;\n      margin-bottom: 8px;\n      align-items: center;\n    }\n    .Filters {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      flex-wrap: wrap;\n      gap: 10px;\n\n      .SelectInput {\n        flex-shrink: 0;\n        width: 140px;\n        // margin-inline-end: 10px;\n      }\n    }\n    .Legend {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 0 14px;\n      &__Item {\n        display: flex;\n        align-items: center;\n        &:not(:last-child) {\n          margin-inline-end: 20px;\n        }\n      }\n      &__ColorBox {\n        min-width: 12px;\n        height: 12px;\n        margin-inline-end: 4px;\n        border: 1px solid;\n      }\n      @media (max-width: 1919px) {\n        position: absolute;\n        top: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n      }\n    }\n\n    .Controls {\n      display: flex;\n      align-items: center;\n      justify-content: space-evenly;\n      .ControlsItem {\n        cursor: pointer;\n        &:not(:last-of-type) {\n          padding-inline-end: 10px;\n          border-inline-end: 1px solid var(--borderColor);\n        }\n        &:nth-of-type(2) {\n          padding-inline-start: 10px;\n        }\n        svg {\n          transition: 0.3s;\n          &:hover {\n            color: var(--secondaryColor);\n            line {\n              stroke: var(--secondaryColor);\n            }\n            path {\n              stroke: var(--secondaryColor);\n            }\n          }\n        }\n      }\n    }\n  }\n\n  &__TableRow {\n    &__AddCell {\n      opacity: 0;\n      transition: all 0.4s;\n      cursor: pointer;\n    }\n    &:hover &__AddCell {\n      opacity: 1;\n    }\n    &:not(:last-child) {\n      border-bottom: 1px solid var(--borderColor);\n    }\n    a {\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      display: block;\n      width: 90%;\n      font-size: 10px;\n      // Added to fix the [export png] arabic letters issue\n      word-break: normal;\n      letter-spacing: normal;\n      // Added to fix the [export png] arabic letters issue\n    }\n  }\n\n  &__SeeAll {\n    border-top: 1px solid var(--borderColor);\n    padding-top: 12px;\n    text-align: center;\n    a {\n      color: var(--secondaryColor);\n      @include fontSize(10);\n    }\n  }\n  :global {\n    .MuiTableCell-root {\n      padding: 9px 0 !important;\n      color: var(--mainColor) !important;\n      text-transform: capitalize;\n      font-size: 10px !important;\n      line-height: 12px;\n      max-width: 162px;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      // Added to fix the [export png] arabic letters issue\n      word-break: normal;\n      letter-spacing: normal;\n      // Added to fix the [export png] arabic letters issue\n      #{$ltr} & {\n        font-family: $latoRegular;\n      }\n      #{$rtl} & {\n        font-family: $CairoRegular;\n      }\n      &:first-of-type {\n        // padding: 0 !important;\n        padding-block: 10px;\n      }\n      // @media screen and(max-width: 1320px) and (min-width: 960px) {\n      //   font-size: 7px !important;\n      //   p {\n      //     font-size: 7px !important;\n      //   }\n      //   max-width: 65px;\n      // }\n    }\n    .MuiTableCell-head {\n      @include fontSize(12);\n      white-space: nowrap;\n      padding-inline-end: 10px !important;\n      // @media screen and(max-width: 1320px) and (min-width: 960px) {\n      //   font-size: 7px !important;\n      // }\n    }\n    .MuiTableRow-root {\n      td:nth-child(2) {\n        padding-inline-start: 10px !important;\n      }\n    }\n\n    .apexcharts-tooltip {\n      padding: 17px 10px;\n      overflow: visible;\n      border-radius: 0;\n      border: 1px solid var(--borderColor);\n\n      & * {\n        vertical-align: middle;\n      }\n\n      &-title {\n        display: none;\n      }\n\n      &-series-group {\n        padding: 0;\n      }\n\n      &-marker {\n        margin-right: 0;\n        #{$rtl} & {\n          margin-left: 10px;\n        }\n        #{$ltr} & {\n          margin-right: 10px;\n        }\n        border-radius: 0;\n      }\n      &-y-group {\n        font-size: 0;\n      }\n\n      &-text-value {\n        margin-left: 0;\n        margin-inline-start: 10px;\n        @include fontSize(10);\n      }\n    }\n  }\n\n  .noBorder {\n    border-bottom: none !important;\n    // height: 32px;\n  }\n\n  a:hover {\n    color: var(--secondaryColor) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `SecondaryTable_scroll__XqUCm`,
	"SecondaryTable": `SecondaryTable_SecondaryTable__TH+yE`,
	"SecondaryTable__Container": `SecondaryTable_SecondaryTable__Container__MfLmA`,
	"SecondaryTable__TableContent": `SecondaryTable_SecondaryTable__TableContent__TpiIU`,
	"SecondaryTable__TopBar": `SecondaryTable_SecondaryTable__TopBar__USpRe`,
	"Date": `SecondaryTable_Date__rXOIq`,
	"FiltersWrapper": `SecondaryTable_FiltersWrapper__fsnLE`,
	"Filters": `SecondaryTable_Filters__hjD1c`,
	"SelectInput": `SecondaryTable_SelectInput__mNCvs`,
	"Legend": `SecondaryTable_Legend__mpuwa`,
	"Legend__Item": `SecondaryTable_Legend__Item__u2-n7`,
	"Legend__ColorBox": `SecondaryTable_Legend__ColorBox__TOije`,
	"Controls": `SecondaryTable_Controls__sXO9J`,
	"ControlsItem": `SecondaryTable_ControlsItem__rmtX2`,
	"SecondaryTable__TableRow__AddCell": `SecondaryTable_SecondaryTable__TableRow__AddCell__ZC4Qc`,
	"SecondaryTable__TableRow": `SecondaryTable_SecondaryTable__TableRow__msmzE`,
	"SecondaryTable__SeeAll": `SecondaryTable_SecondaryTable__SeeAll__jh8ag`,
	"noBorder": `SecondaryTable_noBorder__Mw7q7`
};
export default ___CSS_LOADER_EXPORT___;
